import ApiClient from '@/utils/apiClient'

import type { Brand } from '@/types/brand'

class BrandService {
  apiClient: any
  constructor() {
    this.apiClient = new ApiClient(import.meta.env.VITE_DX_API_URL)
  }

  getBrands = async (bpId: number | null, filters: any): Promise<{ brands: Brand[], totalFilteredCount: number }> => {
    const response = await this.apiClient.get(
      `businessProfiles/${bpId}/brands/search`,
      filters
    )

    const brands = response.data.map((brand: any) => ({
      id: brand.id,
      name: brand.name,
      colours: brand.attributes?.Colors ?? [],
      logoUrls: (brand.assets?.Logo ?? []).map((logo: string) => ({
        logoUrl: logo,
        loading: false,
      })),
      createdAt: brand.createdAt,
    }))

    return {
      brands,
      totalFilteredCount: response.totalFilteredBrands
    }
  }
}

export default BrandService
